interface DownloadDataSVGProps {
    iconColor: string;
}

const DownloadDataSVG = (props: DownloadDataSVGProps) => {
    return (
        <div>
            <button className="opacity-90 hover:opacity-100 flex-shrink-0">
                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.75 11.75V0.75M9.75 11.75L4.75 7.16667M9.75 11.75L14.75 7.16667M18.75 11.75V15.4167C18.75 15.9029 18.5393 16.3692 18.1642 16.713C17.7891 17.0568 17.2804 17.25 16.75 17.25H2.75C2.21957 17.25 1.71086 17.0568 1.33579 16.713C0.960714 16.3692 0.75 15.9029 0.75 15.4167V11.75"
                        stroke={props.iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

        </div>
    );
}

export default DownloadDataSVG;